<template>
  <section>
    <el-row class="content-top">
      <el-button
        v-if="$auth.user().role === 'root'"
        @click="add = true"
        type="primary"
      >
        <i class="el-icon-plus"></i>
        {{ $t('pages.apps.addApp') }}
      </el-button>

      <el-input
        v-model="search"
        style="float: right; width: 260px;"
        :placeholder="$t('pages.apps.enter_app_name')"
        icon="search"
      ></el-input>
    </el-row>

    <el-table :data="filteredApps">
      <el-table-column
        prop="id"
        width="80"
        :label="$t('pages.apps.id')"
      ></el-table-column>
      <el-table-column
        prop="name"
        width="140"
        :label="$t('pages.apps.name')"
      ></el-table-column>
      <el-table-column
        prop="description"
        :label="$t('pages.apps.description')"
      ></el-table-column>
      <el-table-column
        min-width="160"
        :lable="$t('pages.apps.app_key')"
      >
        <template slot-scope="scope">
          <p class="code">App Key: <span>{{scope.row.app_key}}</span></p>
          <p class="code">App Secret: <span>{{scope.row.app_secret}}</span></p>
          <p class="code">Api Key: <span>{{scope.row.api_key}}</span></p>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        align="center"
        :label="$t('pages.apps.is_active')">
        <template slot-scope="scope">
          <i v-if="scope.row.is_active" class="el-icon-check"></i>
          <i v-else class="el-icon-close" ></i>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        align="center"
        :label="$t('common.operation')"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="manageApp(scope.row)">{{ $t('pages.apps.manage') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="add" :title="$t('pages.apps.addApp')" @close="resetAdd">
      <el-form :model="appForm" :rules="addFromRule" ref="addForm" label-width="100px">
        <el-form-item prop="name" :label="$t('pages.apps.name')">
          <el-input v-model="appForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.apps.base_url')" prop="base_url">
          <el-input v-model="appForm.base_url"></el-input>
        </el-form-item>
        <el-form-item prop="description" :label="$t('pages.apps.description')">
          <el-input type="textarea" v-model="appForm.description" @keyup.enter.native="addApp"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addApp">{{ $t('common.save') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
  export default {
    name: 'Applications',
    data() {
      const stringValidator = (rule, value, cb) => {
        if (value.trim() === '') {
          cb(new Error(this.$t('rules.app_name')));
        } else {
          cb();
        }
      };
      return {
        search: '',
        apps: [],
        add: false,
        appForm: {
          name: '',
          description: '',
        },
        addFromRule: {
          name: [
            { required: true, validator: stringValidator },
          ],
         /* base_url: [
            { required: true, message: this.$t('rules.base_url') },
          ], */
        },
      };
    },
    computed: {
      filteredApps() {
        if (!this.search) {
          return this.apps;
        }

        return this.apps.filter(app =>
          app.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
      },
    },
    methods: {
      resetAdd() {
        this.$refs.addForm.resetFields();
      },
      formatDatetime(r, c) {
        const ds = r[c.property];
        return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
      },
      fetchApps() {
        this.$api.listApps().then((res) => {
          this.apps = res.data.applications;
        });
      },
      addApp() {
        this.$refs.addForm.validate((validate) => {
          if (validate) {
            this.$api.addApp(this.appForm).then(() => {
              this.add = false;
              this.resetAdd();
              this.fetchApps();
            });
          }
          return validate;
        });
      },
      manageApp(row) {
        this.$router.push({
          name: 'app_manage',
          params: {
            appId: row.id,
          },
        });
      },
    },
    created() {
      this.fetchApps();
    },
  };
</script>

<style scoped>
.code span {
  color: #242c40cc;
}
</style>



// WEBPACK FOOTER //
// Applications.vue?714d5e61